export function Card({ title, subtitle, actions, children }) {
    return (
      <section className="bg-white border border-gray-200 rounded-xl shadow-[0_1px_2px_rgba(0,0,0,0.04),_0_8px_24px_rgba(0,0,0,0.06)]">
        {(title || actions) && (
          <header className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
            <div>
              {title && <h3 className="text-lg font-semibold text-gray-900">{title}</h3>}
              {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
            </div>
            {actions}
          </header>
        )}
        <div className="p-5">{children}</div>
      </section>
    );
  }
  